// extracted by mini-css-extract-plugin
export var infoRow = "_rk-2";
export var labelContainer = "_rk-0";
export var rightInfo = "_rk-1";